import { OptionType } from '@evinced-private/ui-common';

// Default date range in days - used across all dashboard components
export const DEFAULT_DATE_RANGE_DAYS = 30;

// Date range options used by both pages
export const DASHBOARD_DATE_RANGE_OPTIONS: OptionType[] = [
	{ value: DEFAULT_DATE_RANGE_DAYS, label: 'Last 30 days' },
	{ value: 7, label: 'Last 7 days' },
	{ value: 90, label: 'Last 90 days' }
];
